import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import { Magnetic } from '@mitchell/react.component.ux';
export const StyledActionControlsSection = styled('div') `
	padding: 0 ${Magnetic.spacer24} ${Magnetic.spacer24} ${Magnetic.spacer24};
	box-sizing: inherit;
`;
export const StyledDivDefaultImage = styled(Grid, {
    shouldForwardProp: prop => prop !== 'backgroundImage'
})((props) => `
	background: ${Magnetic[props.backgroundImage]} no-repeat center;
	height: 176px;
    margin: ${Magnetic.spacer16} 0 ${Magnetic.spacer12} 0;
    width: 100%;
`);
export const StyledDivImageContainer = styled('div') `
	text-align: center;
	position: relative;
	padding: ${Magnetic.spacer20} 0 ${Magnetic.spacer24} 0;
	overflow: auto;
	margin: ${Magnetic.spacer12} 0 ${Magnetic.spacer24} 0;
`;
export const StyledGridTopButtonContainer = styled(Grid) `
	position: absolute;
	width: 100%;
	top: 0;
`;
export const StyledGridBottomButtonContainer = styled(Grid) `
	position: absolute;
	width: 100%;
	bottom: 0;
`;
export const StyledDivButtonInnerContainer = styled('div') `
	width: 190px;
	display: flex;
	justify-content: space-between;
`;
const StyleDivBaseImage = `
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	width: 50px;
	height: 50px;
	outline: ${Magnetic.buttonFlatBorder};
	border-radius: 100%;
	border: ${Magnetic.buttonFlatBorder};
`;
export const StyledButtonFourCorner = styled('button') `
    ${StyleDivBaseImage}	
	background-color: ${(props) => props.backgroundColor};
	color: ${Magnetic.colorWhite}; 
`;
export const StyledImageFourCorner = styled('img') `
    ${StyleDivBaseImage}
	cursor: ${Magnetic.buttonBaseCursor};
`;
//# sourceMappingURL=FourCornersComponent.style.js.map